import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

type PaginationDirection = 'next' | 'prior';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    imports: [CommonModule]
})
export class PaginatorComponent {
  @Input() id?: string;

  @Input() page = 0;
  @Input() pageSize = 10;
  @Input() totalRegisters = 0;
  @Input() disabled = true;
  @Output() changePage = new EventEmitter<number>();

  get pageRange() {
    if (!this.totalRegisters) {
      return '0 - 0 de 0';
    }

    const firstPageRegister = this.page * this.pageSize + 1;
    const lastPageRegister = Math.min(
      firstPageRegister + this.pageSize - 1,
      this.totalRegisters
    );

    return `${firstPageRegister} - ${lastPageRegister} de ${this.totalRegisters}`;
  }

  handleChangePage(value: PaginationDirection) {
    value === 'next' ? this.handleNextPage() : this.handlePriorPage();
  }

  handleNextPage() {
    if (this.hasRegisters() && !this.isLastPage()) {
      this.page++;
      this.changePage.emit(this.page);
    };
  }

  handlePriorPage() {
    if (this.hasRegisters() && !this.isFirstPage()) {
      this.page--;
      this.changePage.emit(this.page);
    };
  }

  hasRegisters() {
    return this.totalRegisters > 0;
  }

  isLastPage() {
    if (this.totalRegisters === 0) return true;

    const totalPages = Math.ceil(this.totalRegisters / this.pageSize);
    return this.page === totalPages - 1;
  }

  isFirstPage() {
    return this.page === 0;
  }

  isDisabled() {
    return this.disabled || !this.hasRegisters();
  }

  isPriorButtonDisabled() {
    return this.disabled || this.isFirstPage();
  }

  isNextButtonDisabled() {
    return this.disabled || this.isLastPage();
  }
}
